export default function Signature() {
  return (
    <div
      data-testid="creator-signature"
      className="fixed bottom-4 right-5 z-[90] pointer-events-none select-none text-right"
      style={{ textShadow: "0 1px 8px rgba(0,0,0,0.7)" }}
    >
      <div className="font-display text-[11px] tracking-[0.32em] text-[#C5A059]">
        RAJ GOYAL
      </div>
      <div className="font-nav text-[9px] tracking-[0.22em] text-[#B8A795] mt-[3px]">
        RajGoyal.com
      </div>
    </div>
  );
}
